import React, { Fragment } from "react";
import _ from "lodash";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { AutoCompleteInput, PercentInput } from "components/Global/FormikMaterial";
import CloseButton from "components/Global/Buttons/CloseButton";

const FundNameAutoCompleteContainer = styled(Grid)`
&& > div{
  margin-top:0
}
`;
const FundNameAutoCompleteInput = styled(AutoCompleteInput)`
  &&& div {    
    color:#000;
  }
`;
const ViewFundName = styled(Grid)`
  font-size: 17px;
  text-align:right;
  margin:0;
  padding:0;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
  
  &&{
    margin-top:-2px;
    margin-left:13px;
  }
`;
const ViewAllocationPercent = styled(Grid)`
  input{
    padding:0;
    margin-top:-1px;
    margin-left:-7px;
    min-width:50px;
  }

  &&& {
    margin-top: 0;
  }
`;
const EditAllocationPercent = styled(Grid)`

      
&&& {
    margin-top: 5px;
    margin-left: 10px;
    min-width:50px;
  }
`;
const DeleteFundButton = styled(CloseButton)`
  &&& {    
    height:30px;
  }
`;

const HidePctSpacer = styled(Grid)`
  &&& {    
    padding:0;
  }
`;

const AllocationPercentGrid = ({ isEditing, ...rest }) => {
  if (isEditing) {
    return (<EditAllocationPercent {...rest} />);
  }

  return <ViewAllocationPercent {...rest} />;
};
const getFundName = (fundOptions, id) => {
  const found = _.find(fundOptions, x => x.value === id);
  if (found) {
    return found.label;
  }

  return "--";
};
const FundSelectAndPercent = ({ fundOptions, index, fundId, isEditing, removeFund, shouldShowPercentInput, isCollaborationGroup }) => {
  const term = isCollaborationGroup ? "collaborationGroups" : "funds";

  return (
    <Grid container spacing={8}>
      {(!shouldShowPercentInput && !isCollaborationGroup) && <HidePctSpacer item xs={1} />}
      {!isEditing && <ViewFundName name={`fundNameField${fundId}`} item xs={shouldShowPercentInput || isCollaborationGroup ? 6 : 7}>{getFundName(fundOptions, fundId)}</ViewFundName>}
      {isEditing && <FundNameAutoCompleteContainer item container xs={isCollaborationGroup ? 7 : 5} alignItems="flex-start">
        <FundNameAutoCompleteInput
          key={index}
          validateOnChange
          label=""
          fieldName={`${term}[${index}].id`}
          selectName="label"
          selectValue="value"
          isDisabled={!isEditing}
          required
          options={fundOptions}
        />
      </FundNameAutoCompleteContainer>}
      {shouldShowPercentInput && <AllocationPercentGrid isEditing={isEditing} item container xs={2} alignItems="flex-start">
        <PercentInput
          placeholder={isEditing ? "%" : ""}
          label=""
          disabled={!isEditing}
          required
          validateOnChange
          fieldName={`${term}[${index}].fundDealBridge.allocationPercent`}
        />
      </AllocationPercentGrid>}
      {(isEditing && removeFund) && <Grid item container xs={1} alignItems="center">
        <DeleteFundButton style={{ marginLeft: isCollaborationGroup ? "10px" : "" }} id={`removeFundButton${index}`} onClick={() => removeFund(index)} className="crose" />
      </Grid>}
    </Grid>
  );
};
export default FundSelectAndPercent;
